module.exports = __webpack_public_path__ + "static/logo-e4494a43c3f96671d0f27c6afd5df74e.svg";